export const products = {
  FLY: 'Flight',
  STAY: 'Hotel',
  DRIVE: 'Car',
  PACKAGE: 'Package'
};
export const productsType = {
  FLY: 'FLY',
  STAY: 'STAY',
  DRIVE: 'DRIVE',
  PACKAGE: 'PACKAGE'
};
export const mapPinType = {
  AIRPORT: 'AIRPORT',
  ATTRACTION: 'ATTRACTION',
  BEACH: 'BEACH',
  CITY: 'CITY',
  HOTEL: 'HOTEL',
  MUSEUM: 'MUSEUM',
  POI: 'POI',
  RESTAURANT: 'RESTAURANT',
  MOUNTAIN: 'MOUNTAIN',
  PARK: 'PARK',
  ACTIVITY: 'ACTIVITY'
};
export const viewType = {
  // STAY: 'STAY', Not a valid viewType, use STAYDETAILS OR STAYLISTINGS instead.
  STAYDETAILS: 'STAYDETAILS',
  STAYLISTINGS: 'STAYLISTINGS',
  FLY: 'FLY',
  DRIVE: 'DRIVE',
  PORTAL: 'PORTAL',
  CHECKOUT: 'CHECKOUT',
  LANDING: 'LANDING',
  ITINERARY: 'ITINERARY',
  PACKAGE: 'PACKAGE'
};
// App name to product type mapping
export const appNameMap = {
  relax: [viewType.STAYLISTINGS],
  'relax-at': [viewType.STAYDETAILS],
  'travel-itinerary': [viewType.ITINERARY],
  'drive-search-responsive': [viewType.DRIVE],
  'fly-search': [viewType.FLY],
  'package-search': [viewType.PACKAGE],
  'next-landing': [viewType.LANDING],
  'cart-checkout': [viewType.CHECKOUT]
};
export const viewTypeToProductIdMap = {
  [viewType.PORTAL]: -1,
  [viewType.FLY]: 1,
  // [viewType.STAY]: 5,
  [viewType.STAYDETAILS]: 5,
  [viewType.STAYLISTINGS]: 5,
  [viewType.DRIVE]: 8,
  [viewType.PACKAGE]: 17
};